import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from '@/components/ui/sonner';
import { SheetProvider } from './contexts/user-settings';
import App from './app.tsx';
import { clearStorage } from './utility/storage';
import './main.css';

clearStorage();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SheetProvider>
      <App />
      <Toaster richColors position="top-center" swipeDirections={['left', 'right', 'top', 'bottom']} duration={6000} />
    </SheetProvider>
  </StrictMode>,
);
